import type {
	ClientPortfolioDetailRelatedResponseDTO,
	PortfolioDocumentListItemDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type { NormalizedTool } from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { isServiceOrAdvisoryDomain } from "web_myplann/Portfolio/Helpers/isServiceOrAdvisoryDomain";

export function computeRelatedPresence(
	documents: PortfolioDocumentListItemDTO[] | undefined,
	related: ClientPortfolioDetailRelatedResponseDTO[] = [],
	tools?: NormalizedTool[],
) {
	const hasDocuments = !!documents && documents.length > 0;
	const hasRelatedContracts = related.some(
		(r) =>
			r.relatedPortfolio &&
			!isServiceOrAdvisoryDomain(r.relatedPortfolio.domain),
	);
	const hasRelatedProperties = related.some((r) => r.relatedProperty);
	const hasRelatedServices = related.some(
		(r) =>
			r.relatedPortfolio?.domain &&
			isServiceOrAdvisoryDomain(r.relatedPortfolio.domain),
	);
	const hasTools = Array.isArray(tools) && tools.length > 0;

	return {
		hasDocuments,
		hasRelatedContracts,
		hasRelatedProperties,
		hasRelatedServices,
		hasTools,
		hasAny:
			hasDocuments ||
			hasRelatedContracts ||
			hasRelatedProperties ||
			hasRelatedServices ||
			hasTools,
	};
}
